<template>
  <div class="flex flex-col">
    <div class="text-xs font-bold text-white">
      {{ this.$t('frontend_builder_text_section_font')}}
    </div>
    <div class="flex-grow flex-1 flex items-center">
      <gd-dropdown
        v-model="selected"
        :options="options"
        styled="font-family"
        variant="dark"
        size="full"
      />
    </div>
  </div>
</template>

<script>
import GdDropdown from '@groovepages/gd-ui-kit/components/Dropdown';
import tailwindConfig from '@groovepages/gp-page-ui-kit/tailwind';

export default {
  name: 'FontSelector',
  components: {
    GdDropdown,
  },
  props: {
    fontData: {
      default: () => tailwindConfig.fontsData
    },
    value: {
      type: String,
      default: '',
    },
    hideDefault: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(font) {
        this.$emit('input', font);
      },
    },
    options() {
      const options = Object.keys(this.fontData).map((text) => {
        const option = this.fontData[text];
        return { text, value: option };
      });
      return options;
    },
  },
};
</script>
